import type { AxiosRequestConfig } from "axios";

export const repeatedBareArrayParamsSerializer: AxiosRequestConfig["paramsSerializer"] = {
  indexes: null,
};
